import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import cohortsImg from "../../../../../assests/cohortsImg.svg";
import "./CohortSuccessComponent.css"; // 👈 Add CSS file for styling

const CohortSuccessComponent = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="success-container">
      <div className="success-content">
        <div className="success-image-wrapper">
          <img
            src={cohortsImg}
            alt="Success Icon"
            className="success-image"
          />
        </div>
        <h2 className="success-message">
          Cohort Created Successfully with ID: <span>{props.cohortId}</span>
        </h2>
        <p className="success-thankyou">Thank you</p>
        <button
          className="success-button"
          onClick={() => navigate("/home/configuration/cohortslist")}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default CohortSuccessComponent;
